module.exports = __webpack_public_path__ + "static/media/Member.9efc1595.png";